import { Record, List } from 'immutable'

export const PendingRecord = Record({
  getNotifications: false,
  getNotificationsLoadMore: false,
})

export class Pending extends PendingRecord {}

export const LoadedRecord = Record({
  getNotifications: false,
  getNotificationsLoadMore: false,
})

export class Loaded extends LoadedRecord {}

export const NotificationsPaginationRecord = Record({
  count: 0,
  limit: 30,
  page: 0,
})

export class NotificationsPagination extends NotificationsPaginationRecord {}

export const NotificationsRecord = Record({
  notifications: List(),
  pending: new Pending(),
  loaded: new Loaded(),
  notificationsPagination: new NotificationsPagination(),
  scrollTop: 0,
  unreadCount: 0,
})

export class Notifications extends NotificationsRecord {}
